import AjaxService from '../services/ajax-service';
import { handleServerError } from 'shared-services/error-service';
import { convertToFormData } from '../utils/helpers';

export const fetchTeams = ({ limit, offset }, token) => {
    return AjaxService({
        method: 'get',
        url: `teams`,
        params: {
            limit,
            offset
        }
    }, true, token)
        .then(response => response?.data)
        .catch(handleServerError);
}

export const fetchLinkedTeams = ({ limit, offset }, token) => {
    return AjaxService({
        method: 'get',
        url: `teams/linked_teams`,
        params: {
            limit,
            offset
        }
    }, true, token)
        .then(response => response?.data)
        .catch(handleServerError);
}

export const createTeam = ({ url, name, logo, chat_disabled, client_chat_disabled, plan, signup, sumoCode, stripeSessionId }) => {
    return AjaxService({
        method: 'post',
        url: 'teams',
        data: convertToFormData({
            url,
            name,
            logo,
            chatDisabled: chat_disabled,
            client_chat_disabled,
            plan,
            signup,
            sumoCode,
            stripe_session_id: stripeSessionId
        })
    }, true)
        .then(response => response?.data);
}

export const fetchTeam = teamToken => {
    return AjaxService({
        method: 'get',
        url: `teams`,
        params: {
            current: true
        }
    }, false, teamToken)
    .then(response => response?.data)
    .catch(handleServerError);
}

export const fetchTeamByToken = token => {
    return AjaxService({
        method: 'get',
        url: `api/team`
    }, false, token)
    .then(response => response?.data)
    .catch(handleServerError);
}

export const fetchTeamDetails = () => {
    return AjaxService({
        method: 'get',
        url: `teams/details`
    })
    .then(response => response?.data)
    .catch(handleServerError);
}

export const updateTeam = ({ url, cname, name, logo, chat_disabled, client_chat_disabled, ignore_weekends, plan, source_id, login_policy, time_tracking_provider, billing_info }) => {
    const data = {
        url,
        cname,
        name,
        logo,
        chatDisabled: chat_disabled,
        client_chat_disabled,
        ignore_weekends,
        plan,
        source: source_id,
        login_policy,
        time_tracking_provider,
        billing_info
    }

    return AjaxService({
        method: 'put',
        url: `teams`,
        data: logo ? convertToFormData(data) : data
    })
        .then(response => response?.data)
        .catch(handleServerError);
}

export const changePlan = ({ plan, source, stateTax, coupon, minSeats }) => {
    return AjaxService({
        method: 'post',
        url: `teams/plan`,
        data: {
            plan,
            source,
            stateTax,
            coupon,
            min_seats: minSeats
        }
    })
        .then(response => response?.data)
        .catch(handleServerError);
}

export const removeTeam = withUser => {
    return AjaxService({
        method: 'delete',
        url: `teams`,
        data: {
            user: withUser
        }
    })
        .then(response => response?.data)
        .catch(handleServerError);
}

export const inviteTeamUsers = invitees => {
    return AjaxService({
        method: 'post',
        url: `teams/invite`,
        data: {
            invitees: invitees.map(user => ({
                email: user.email,
                role: user.role,
                name: user.name
            }))
        }
    })
        .then(response => response?.data)
        .catch(handleServerError);
}

export const leaveTeam = teamUrl => {
    return AjaxService({
        method: 'post',
        url: `teams/leave`
    }).then(response => response?.data);
}

export const transferTeam = (member_id, role) => {
    return AjaxService({
        method: 'post',
        url: `teams/transfer`,
        data: { member_id, role }
    }).then(response => response?.data);
}

export const transferTeamBilling = member_id => {
    return AjaxService({
        method: 'post',
        url: `teams/transfer/billing`,
        data: { member_id }
    }).then(response => response?.data);
}

export const getTeamAccess = (teamUrl, token) => {
    return AjaxService({
        method: 'get',
        url: `teams/access/${teamUrl}`
    }, false, token).then(response => response?.data);
}
